import { SubUser } from '../../../types/models/user/user.types';
import { USERS_ENDPOINTS } from '../../../utils/api/endpoints/usersEndpoints';

const PREFIX = '[subUsersENTQuery]';

export const subUsersENTQuery = async () => {
  console.log(PREFIX, `Fetching all sub users ENT...`);

  const response = await USERS_ENDPOINTS.subUsersENT();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all sub users ENTÒ..`);
  return json as SubUser[];
};
